import SiBell from '@/icons/SiBell';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { FunctionComponent, ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface BaseNotificationProps {
  title: string;
  description: string;
  date: Date;
  read: boolean;
  link: string;
  icon?: ReactElement;
  onClick?: () => void;
}

const BaseNotification: FunctionComponent<BaseNotificationProps> = ({ title, description, date, link, icon, read, onClick }) => {
  return (
    <Link onClick={onClick} to={link} className={cn('flex space-x-5 p-4', read ? 'opacity-70' : 'font-semibold')}>
      {icon ? (
        icon
      ) : (
        <div className="relative bg-primary-100 flex h-10 w-10 items-center justify-center rounded-full">
          <SiBell className="text-primary-700 h-6 w-6" />
        </div>
      )}
      <div className="text-left">
        <p className="text-sm">{format(date, 'dd/MM/yyyy HH:MM:SS')}</p>
        <p className="text-xl">{title}</p>
        <p className="text-sm">{description}</p>
      </div>
    </Link>
  );
};

export default BaseNotification;
